import { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
const Context = createContext({ visible: false, loading: true, revision: 0 });
export function PromotionProvider({ children }) {
  const [state, setState] = useState({ visible: false, loading: true, revision: 0 });
  useEffect(() => {
    let disposed = false, timer, controller;
    const refresh = async () => {
      clearTimeout(timer);
      controller?.abort();
      controller = new AbortController();
      let delay = 60000;
      try {
        const { data } = await axiosInstance.get("/promotions/visibility", { signal: controller.signal });
        if (disposed) return;
        setState((s) => ({ ...data, loading: false, revision: s.revision + 1 }));
        if (data.nextTransitionAt) delay = Math.min(delay, Math.max(250, Date.parse(data.nextTransitionAt) - Date.parse(data.serverTime) + 100));
      } catch (error) {
        if (disposed || error.code === "ERR_CANCELED") return;
        setState((s) => ({ ...s, visible: s.mode === "show", loading: false }));
      }
      if (!disposed) timer = setTimeout(refresh, delay);
    };
    const onFocus = () => { if (!document.hidden) refresh(); };
    refresh();
    window.addEventListener("promotions:refresh", refresh);
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => { disposed = true; clearTimeout(timer); controller?.abort(); window.removeEventListener("promotions:refresh", refresh); window.removeEventListener("focus", onFocus); document.removeEventListener("visibilitychange", onFocus); };
  }, []);
  return <Context.Provider value={state}>{children}</Context.Provider>;
}
export const usePromotions = () => useContext(Context);
